module.exports = {
  None: 0,
  Employee: 1,
  Customer: 2,
  Handler: 3,
  System: 4,
  ForwardingEmployee: 5
}
